import { isEmpty } from 'lodash'

export const getConfig = () => {
    const data = localStorage.getItem('aupd_config');

    if (isEmpty(data)) {
        return {};
    } else {
        try {
            return JSON.parse(data)
        } catch (e) {
            return {}
        }
    }
}
